import { useEffect, useRef, useState } from 'react';
import { googletag } from '~/types/global';

import { useLocation } from '@remix-run/react';

import AdText from './AdText';

function SidebarDesktopAd() {
  const location = useLocation();
  const slotRef = useRef<googletag.Slot | null>(null);
  const [adLoaded, setAdLoaded] = useState<boolean>(false);

  const handleSlotRenderEnded = (
    event: googletag.SlotRenderEndedEvent,
  ): void => {
    if (slotRef.current && event.slot === slotRef.current) {
      setAdLoaded(!event.isEmpty);
    }
  };

  useEffect(() => {
    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(() => {
      const slot = window.googletag
        .defineSlot(
          '/46481815/8legs.app/8legs.app_sidebar_desktop',
          [[300, 250]],
          'div-gpt-ad-8legs.app_sidebar_desktop',
        )
        ?.addService(window.googletag.pubads());

      if (slot) {
        slotRef.current = slot;
      }

      window.googletag
        .pubads()
        .addEventListener('slotRenderEnded', handleSlotRenderEnded);
      window.googletag.enableServices();
      window.googletag.display('div-gpt-ad-8legs.app_sidebar_desktop');
    });

    return () => {
      window.googletag.cmd.push(() => {
        if (slotRef.current) {
          window.googletag.destroySlots([slotRef.current]);
          slotRef.current = null;
        }
        window.googletag
          .pubads()
          .removeEventListener('slotRenderEnded', handleSlotRenderEnded);
      });
    };
  }, [location]);

  const containerStyle = {
    display: adLoaded ? 'block' : 'none',
  } as const;

  return (
    <div style={containerStyle}>
      <AdText />
      <div id='div-gpt-ad-8legs.app_sidebar_desktop' />
    </div>
  );
}

export default SidebarDesktopAd;
